import React from "react";

import "./contact-box.scss";

const ContactBox = () => (
  <div className="contact-box">
    <p>Have a project or idea you'd like to collaborate on? Reach out to us</p>
    <a href="mailto:hey@mobiux.in" className="btn btn-primary">hey@mobiux.in</a>
  </div>
);

export default ContactBox;
